import { useMemo } from "react"
import Qs from "qs"
import { useLocation } from "react-router-dom"

/**
 * A custom hook that builds on useLocation to parse
 * query string
 */
export default function useQueryParams() {
  const search = useLocation().search
  return useMemo(() => Qs.parse(search, { ignoreQueryPrefix: true }), [search])
}
